import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import Section from './Section.js'
import RenderField from './RenderField';
import CustomSpinner from './CustomSpinner';
import CustomAlert from '../components/CustomAlert.js';
import FlowProgressBar from './FlowProgressBar';
import Header from './Header.js';

class Affidavit extends Component {

    render() {
        const { handleSubmit, submitting, error, invalid } = this.props;

        return (
            <Section className="intro_form">
                <div className="row">
                    <Header>
                        <FlowProgressBar />
                        <FormattedHTMLMessage id="app.step_affidavit" description="Affidavit info"/>
                    </Header>
                    <div className='container no-gutters'>
                        <div className="pd-content-bottom col-sm-12 col-md-8 col-lg-8 col-md-offset-2 col-lg-offset-2 text-center">
                            <form onSubmit={handleSubmit(this.props.sentAffidavit)} className="pvc-form">
                                {this.props.isLoading && <CustomSpinner message='Estamos analizando su solicitud. Por favor espere...' /> }
                                {error && <CustomAlert bsStyle="danger" message={error}/>}
                                <div className="row">
                                    <div className="col-sm-12 col-md-12 col-lg-12">
                                        <div className="form-group">
                                            <label>
                                                <h4>Confirmo que los datos ingresados son válidos y se informó al cliente de los Términos y Condiciones de esta subscripción.</h4>
                                            </label>
                                            <Field
                                                className="form-control"
                                                name="tos"
                                                component={RenderField}
                                                showLabel={false}
                                                type="switch"
                                                label=""
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                        <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting || invalid}>Seguir</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}

const validate = values => {
    const errors = {};
    if (!values.tos) {
        errors.tos = 'Required'; //This error message won't be displayed, but it marks the field as invalid.
    }
    return errors;
};

Affidavit = TopScrolleable(Affidavit);

Affidavit = reduxForm({
    initialValues: {
        tos: false,
    },
    form: 'Affidavit',
    validate
})(Affidavit);

Affidavit = withAuthControl(Affidavit);

export default Affidavit;



/** WEBPACK FOOTER **
 ** ./src/components/Affidavit.js
 **/